module.exports = __webpack_public_path__ + "static/img/VILLA-OAK.4a16fbf.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/VILLA-OAK.png
// module id = lxnw
// module chunks = 0